module.exports = __webpack_public_path__ + "static/media/card.4f55b6c4.jpg";